import React, { useCallback } from "react";

import { Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { useNavigate } from "hooks";

export const DealCell: React.FC<{ value: string | null; dealId: number | null }> = ({ value, dealId }) => {
  const navigate = useNavigate();
  const onClick = useCallback(() => {
    if (dealId) {
      navigate({ route: "dealWorkspace", params: { deal_id: dealId } });
    }
  }, [dealId, navigate]);

  return (
    <MaterialTooltip title={value ? `Navigate to deal "${value}"` : "-"} isShow>
      <Typography
        onClick={onClick}
        noWrap
        sx={{
          fontSize: 14,
          color: value ? "#26a6ae" : "#92a7bc",
          lineHeight: "16px",
          display: "block",
          cursor: value ? "pointer" : "default"
        }}
      >
        {value ?? "-"}
      </Typography>
    </MaterialTooltip>
  );
};
